import { getCurrentCircleLocale } from "@circle-react/helpers/localeHelpers";
import flatpickr from "flatpickr";

export const setFlatpickrLocale = async () => {
  const currentLocale = getCurrentCircleLocale();

  if (currentLocale === "pt" || currentLocale === "pt-PT") {
    const locale = await import(
      /* webpackChunkName: "flatpickr_pt" */ "flatpickr/dist/l10n/pt"
    );

    flatpickr.setDefaults({
      locale: locale.Portuguese,
    });
  } else if (currentLocale === "de") {
    const locale = await import(
      /* webpackChunkName: "flatpickr_de" */ "flatpickr/dist/l10n/de"
    );

    flatpickr.setDefaults({
      locale: locale.German,
    });
  }
};
